import {localize, setLocale} from '@vee-validate/i18n'
import de from '@vee-validate/i18n/dist/locale/de.json'
import en from '@vee-validate/i18n/dist/locale/en.json'
import * as AllRules from '@vee-validate/rules'
import {zxcvbn} from '@zxcvbn-ts/core'
import {configure, defineRule, ErrorMessage, Field, Form} from 'vee-validate'
import additionalDe from './vee-validate/de'
import additionalEn from './vee-validate/en'

const url_regex = '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$' // fragment locator

const rulesForErrorMessage: string[] = [
    'validation_pending',
    'puzzle_unsolved'
]

export default defineNuxtPlugin((nuxtApp) => {

    /**************
     * Custom rules
     **************/

    defineRule('verify_password', (value: string) => {
        if (!value) return true
        return zxcvbn(value).score > 2
    })

    defineRule('confirm_password', (value: string, [target]: [string | undefined]) => {
        if (!target) return false
        return value === target
    })

    defineRule('verify_url', (value: string) => {
        if (!value) return true
        return new RegExp(url_regex, 'i').test(value)
    })

    defineRule('editor_content_required', (value: string) => {
        if (value == null) return false
        const stripped = value.replace(/\s+/g, '')
        return stripped !== '' && stripped !== '<p></p>'
    })

    rulesForErrorMessage.forEach(rule => defineRule(rule, () => false))

    /**************
     * Configuration
     **************/

    // Register all built-in VeeValidate rules
    Object.entries(AllRules).forEach(([ruleName, ruleFn]) => {
        if (ruleName === 'all') return
        defineRule(ruleName, ruleFn as any)
    })

    configure({
        generateMessage: localize({
            en: {...en, messages: {...en.messages, ...additionalEn.messages}},
            de: {...de, messages: {...de.messages, ...additionalDe.messages}}
        })
    })

    setLocale('de')

    nuxtApp.vueApp.component("VField", Field)
    nuxtApp.vueApp.component("VForm", Form)
    nuxtApp.vueApp.component("ErrorMessage", ErrorMessage)

    // Note: VeeValidate v4 no longer supports global class mapping via configure().
    // Apply classes in templates using slot props (meta.valid, meta.dirty, etc.).
})